import { createContext } from "react";

export const CompaniesContext = createContext(null); 